import React from 'react'
import { StatusBasedCard } from './statusBasedCard'

function SimpleCard ({ submitProgress,
  activateSubmitProgress,
  cardColor,
  beforeStartText,
  finishedMessage,
  renderFinishedMessage,
  dataCy,
  ...props }) {
  let status
  let processedCardColor
  if (submitProgress < activateSubmitProgress) {
    status = 'notStarted'
    processedCardColor = 'secondary'
  } else if (submitProgress === activateSubmitProgress) {
    status = 'active'
    processedCardColor = 'primary'
  } else if (submitProgress > activateSubmitProgress) {
    status = 'finished'
    processedCardColor = 'success'
  }

  if (cardColor) processedCardColor = cardColor

  return <StatusBasedCard cardColor={processedCardColor}
    status={status}
    beforeStartText={beforeStartText}
    finishedMessage={finishedMessage}
    renderFinishedMessage={renderFinishedMessage}
    dataCy={dataCy}
    {...props} />
}

export { SimpleCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/simpleCard.js